module.exports = __webpack_public_path__ + "img/nav_logo.361ad9f3.png";